import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  featureFlags: {
    enableAccountDeactivation: false,
    enableSIP: true,
    enableLumpsum: true,
    enableAccountAggregation: false,
    enableNotification: true,
  },
  environment: 'production',
  isLoading: false,
  error: null,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setFeatureConfig: (state, action) => {
      const { enableAccountDeactivation, enableSIP, enableLumpsum, enableAccountAggregation, enableNotification, environment } = action.payload;
      state.featureFlags = {
        enableAccountDeactivation,
        enableSIP,
        enableLumpsum,
        enableAccountAggregation,
        enableNotification,
      };
      state.environment = environment;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setFeatureConfig, setLoading, setError } = configSlice.actions;

export const selectFeatureFlags = (state) => state.config.featureFlags;
export const selectIsLoading = (state) => state.config.isLoading;
export const selectError = (state) => state.config.error;

export default configSlice.reducer;
